import ProfileOptionsMenu from "pages/PanelPage/components/ProfileOptionsMenu/ProfileOptionsMenu";

export default ProfileOptionsMenu;
